export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6676.bcb77b18.jpg";